import React, {useState, useEffect} from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';
import {logPageLoadEvents, sendEvarData} from '@ibibo/analytics';
import {updatePreviousPageName} from '../../store/actions';
import {
  getEmailOtpVerificationData,
  sendEmailOtpDataForVerification,
} from '../../store/actions/thunk';
import {useSelector, useDispatch} from 'react-redux';
import {prevPageNameSelector, mpnfoSelector} from '../../store/selectors';
import LoginPop from './containers/LoginPop';
import EmailVerify from '../../stories/components/OnboardingNew/PopUp/EmailVerify/EmailVerify';
import VerifyPan from '../../stories/components/OnboardingNew/PopUp/PanVerification/VerifyPAN/VerifyPan';
import MobileVerification from '../../stories/components/OnboardingNew/GccComponents/MobileVerification/MobileVerification';
import {updateUrlWithNewCrid} from '../../../../myaccount/src/utils/redirectWithCrId';
import UpdateDetailsForm from '../../../../myaccount/src/stories/components/common/Form/UpdateDetailsForm/UpdateDetailsForm';
import OtpVerified from '../../stories/components/OnboardingNew/CommonComponents/OtpVerified/OtpVerified';
import {Helmet} from 'react-helmet';
import deviceFingerPrinting from 'MMT-UI/DeviceFingerPrinting';
const LoginNew = () => {
  const errorsInitialState = {
    formSubmissionError: '',
    inputBoxError: '',
  };

  const [loginPageFlag, setLoginPageFlag] = useState(true);
  const [verifyEmailFlag, setVerifyEmailflag] = useState(false);
  const [loginFlag, setLoginFlag] = useState(true);
  const [newEmail, setNewEmail] = useState('');
  const [showNewEmailInput, setShowNewEmailInput] = useState(false);
  const [emailOtpError, setEmailOtpErrpr] = useState('');
  let isEmailLoading = false; //to be changed later
  const [emailExist, setEmailExist] = useState(false);
  const [resendEmailOtpActive, setResendEmailOtpActive] = useState(true);
  const [emailActivationLinkInfoData, setEmailActivationLinkInfoData] = useState({});
  const [panVerificatioData, setPanVerificationData] = useState(null);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [verificationScreen, setVerificationScreen] = useState('');
  const [mobileVerificationData, setMobileVerificationData] = useState(null);
  const [verificationData, setVerificationData] = useState(null);
  const [modalUpdateDetailsData, setModalUpdateDetailsData] = useState({
    componentData: {},
    modalData: {},
    formFields: {},
  });

  const [error, setError] = useState(errorsInitialState);

  useEffect(() => {
    updateUrlWithNewCrid();
    scrollIntoView(document.getElementById('onboardingnew'), {
      block: 'start',
      behavior: 'auto',
    });
    deviceFingerPrinting();
  }, []);

  const data = useSelector(prevPageNameSelector);
  const mpnfoValue = useSelector(mpnfoSelector);
  const {prevPageName} = data;
  const dispatch = useDispatch();

  //Email verify functions

  const closeUpdateVerifiedEmailPop = () => {
    sendEvarData(
      {
        prop54: 'emailOTP_skip',
      },
      true,
    );
    const flightRedirectUrl = getCookie('myPartner_b2b_homepage');
    if (flightRedirectUrl === '1' && window.screen.width > 1024) {
      window.open('https://mypartner.makemytrip.com/landing/flights', '_self');
    } else window.open('https://www.makemytrip.com/flights/?action=smartbuy&open=browser', '_self');
  };

  const resentUpdateEmailOtp = () => {};

  const submitUpdateEmailOtp = (data, email) => {
    if (data.length < 4) {
      setEmailOtpErrpr('Invalid OTP, please enter the correct OTP');
    } else {
      dispatch(sendEmailOtpDataForVerification(data, email, otpSuccessCallback, otpErrorCallback));
    }
  };

  const sendUpdateVerifiedEmail = (data, type = 'old') => {};

  const otpSuccessCallback = data => {
    const flightRedirectUrl = getCookie('myPartner_b2b_homepage');
    if (flightRedirectUrl === '1' && window.screen.width > 1024) {
      window.open('https://mypartner.makemytrip.com/landing/flights', '_self');
    } else window.open('https://www.makemytrip.com/flights/?action=smartbuy&open=browser', '_self');
  };

  const otpErrorCallback = data => {
    setEmailOtpErrpr(data);
    sendEvarData(
      {
        prop54: 'otp_error',
      },
      true,
    );
  };

  const getCookie = cname => {
    if (typeof document !== 'undefined') {
      const name = cname + '=';
      const ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
    }
    return '';
  };

  //Email verifiy functions ends here

  //GCC functions
  const popupSuccessCallback = resp => {
    if (resp?.data?.step) {
      const step = resp.data.step;
      if (step == 'VERIFICATION_SUCCESS') {
        setVerificationScreen('VERIFICATION_SUCCESS');
        setModalUpdateDetailsData(prevState => ({
          ...prevState,
          modalData: resp?.data,
        }));
        return;
      }
      setModalUpdateDetailsData(prevState => ({
        ...prevState,
        modalData: verificationData?.data[step],
        formFields: resp?.data?.formFields || {},
      }));
    }
    setError(errorsInitialState);
  };

  const popupErrorCallback = err => {
    setError({...err, formSubmissionError: err.message});
  };

  return (
    <>
      <Helmet meta={[{name: 'robots', content: 'noindex, nofollow'}]} />
      <OnboardingNew step={1} showBackButton={loginPageFlag}>
        {loginPageFlag && (
          <LoginPop
            loginPageFlag={loginPageFlag}
            setLoginPageFlag={setLoginPageFlag}
            setEmailActivationLinkInfoData={setEmailActivationLinkInfoData}
            setPanVerificationData={setPanVerificationData}
            setRedirectUrl={setRedirectUrl}
            setVerificationScreen={setVerificationScreen}
            setMobileVerificationData={setMobileVerificationData}
            setModalUpdateDetailsData={setModalUpdateDetailsData}
            setVerificationData={setVerificationData}
          />
        )}
        {
          <>
            {!loginPageFlag && verificationScreen === 'Email_Verification' && (
              <UpdateDetailsForm
                {...modalUpdateDetailsData?.modalData}
                componentData={verificationData}
                setModalUpdateDetailsData={setModalUpdateDetailsData}
                successCallback={popupSuccessCallback}
                modalUpdateDetailsData={modalUpdateDetailsData}
                flagForBodyData={true}
                errorCallback={popupErrorCallback}
                errorMessages={error}
                updateFormFiledsDataOnLogin={true}
                // closeModal={closeFormModal}
              />
            )}
            {!loginPageFlag && verificationScreen === 'GSTN_PAN_Verification' && (
              <VerifyPan
                panVerificationData={panVerificatioData}
                responseRedirectUrl={redirectUrl}
                screenToShow={verificationScreen}
              />
            )}
            {!loginPageFlag && verificationScreen === 'tdsSlabInformation' && (
              <VerifyPan
                panVerificationData={panVerificatioData}
                responseRedirectUrl={redirectUrl}
                screenToShow={verificationScreen}
              />
            )}
            {!loginPageFlag && verificationScreen === 'Mobile_Verification' && (
              <UpdateDetailsForm
                {...modalUpdateDetailsData?.modalData}
                componentData={verificationData}
                setModalUpdateDetailsData={setModalUpdateDetailsData}
                successCallback={popupSuccessCallback}
                modalUpdateDetailsData={modalUpdateDetailsData}
                flagForBodyData={true}
                errorCallback={popupErrorCallback}
                errorMessages={error}
                updateFormFiledsDataOnLogin={true}
                // closeModal={closeFormModal}
              />
            )}
            {!loginPageFlag && verificationScreen === 'VERIFICATION_SUCCESS' && (
              <OtpVerified
                responseRedirectUrl={redirectUrl}
                message={modalUpdateDetailsData?.modalData?.message}
                heading={modalUpdateDetailsData?.modalData?.heading}
                inportantInfo={modalUpdateDetailsData?.sub_text}
              />
            )}
          </>
        }
      </OnboardingNew>
    </>
  );
};

export default LoginNew;
